
import Cookies from 'universal-cookie';

export default {
  name: 'CookiePreferencesButton',
  data() {
    return {
      showButton: false
    }
  },
  methods: {
    showPreferences() {
      this.$emit('show-preferences');
    },
    checkCookieAcceptance() {
      const cookies = new Cookies();
      this.showButton = !!cookies.get('cookie_accepted');
    }
  },
  mounted() {
    this.checkCookieAcceptance();

    // Watch for changes in cookie acceptance
    this.$root.$on('cookies-accepted', () => {
      this.$nextTick(() => {
        this.checkCookieAcceptance();
      });
    });

    this.$root.$on('cookies-rejected', () => {
      this.$nextTick(() => {
        this.checkCookieAcceptance();
      });
    });
  },
  beforeDestroy() {
    this.$root.$off('cookies-accepted');
    this.$root.$off('cookies-rejected');
  }
}
